var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","align-center":""}},[_c('v-flex',[_c('h3',[_vm._v("Please click Upload to upload "),_c('span',[_vm._v(".csv/.xlsx")]),_vm._v(" file")])]),_vm._v(" "),_c('v-flex',[_c('e-upload',{attrs:{"url":_vm.uploadUrl,"extensions":['.csv', '.xlsx'],"disabled":!_vm.isWriteAvailable}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c0a6150","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Listing/ListingInvitation/multiple.vue
// module id = null
// module chunks = 